import type {InputMaterialConnection, OutputMaterialConnection} from "#material/sockets/definition"
import {GraphNode} from "@cm/graph-v3"
import {CombineRgb} from "#material/nodes/converter/combine-rgb/combine-rgb"
import {materialConnection} from "#material/nodes/base/connection/shorthand"

export function combineRgb(
    r: InputMaterialConnection<"float"> | number,
    g: InputMaterialConnection<"float"> | number,
    b: InputMaterialConnection<"float"> | number,
): OutputMaterialConnection<"color"> {
    const combineRgbNode = new CombineRgb({
        parameters: {
            inputs: {
                r: r instanceof GraphNode ? r : undefined,
                g: g instanceof GraphNode ? g : undefined,
                b: b instanceof GraphNode ? b : undefined,
            },
            settings: {
                r: r instanceof GraphNode ? undefined : r,
                g: g instanceof GraphNode ? undefined : g,
                b: b instanceof GraphNode ? undefined : b,
            },
        },
    })
    return materialConnection(combineRgbNode, "image")
}
